import './initializers/sentry.js'
import * as ActiveStorage from "@rails/activestorage"
import "./channels/consumer.js"
import 'form-request-submit-polyfill'
import "@hotwired/turbo-rails"
import "@rolemodel/turbo-form"
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip'
import '@shoelace-style/shoelace/dist/components/spinner/spinner'
import "@hotwired/hotwire-native-bridge"
import Bridge from './/turbo/bridge'
import "trix"
import "@rails/actiontext"
import './controllers'
import './initializers/turbo_confirm.js'
import './initializers/frame_missing_handler.js'
import './initializers/connection_failed_flash.js'
import './web-components/index.js'

window.bridge = Bridge

ActiveStorage.start()

